import React from 'react';
import './index.css'; 
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


import Home from './pages/Home.jsx';

// blog
import Blog from './pages/Blog.jsx'

import Products from './pages/Products.jsx';
import Contact from './pages/Contact.jsx';
import Promotions from './pages/Promotions.jsx';
import Brands from './pages/Brands.jsx';
import ProductInfo from './pages/ProductInfo.jsx';




function App() {
  return (
    <Router>
      <div className="App">

        <Routes>
        <Route path="" element={<Home />} />
          <Route path="/blog" element={<Blog/>} />
          <Route path="/home" element={<Home/>} />
          <Route path="/products" element={<Products/>} />
          <Route path="/brands" element={<Brands/>} />
          <Route path="/promotions" element={<Promotions/>} />
          <Route path="/support" element={<Contact />} />
          <Route path="/product/:id" element={<ProductInfo />} />
        </Routes>

      </div>
    </Router>
  );
}

export default App;

